<template>
  <div>
    <!-- Modal de carregamento -->
    <v-dialog v-model="loading" persistent max-width="300px">
      <v-card color="primary" dark>
        <v-card-text class="d-flex flex-column align-center justify-center pa-8">
          <v-progress-circular indeterminate color="white" size="48" class="mb-4" />
          <span class="text-h6">Aguarde...</span>
          <small class="mt-2">Carregando processos disponíveis</small>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-container class="fill-height d-flex flex-column justify-center align-center mt-10">
      <v-row class="justify-center">
        <template v-if="processos.length > 0">
          <v-col
            v-for="processo in processos"
            :key="processo.id"
            :cols="12"
            :md="processos.length === 1 ? 8 : 6"
            :lg="processos.length === 1 ? 8 : 4"
            class="d-flex justify-center"
          >
            <v-card elevation="8" class="pa-6 text-center card-ajuste card-flex">
              <div class="card-content-flex">
                <v-icon :color="processo.display ? 'primary' : 'info'" :size="56">{{ processo.icon_main }}</v-icon>
                <h2 class="mt-2 mb-2 font-weight-bold">{{ processo.titulo }}</h2>
                <p class="mb-4">{{ processo.chamada }}</p>
                <div class="card-spacer"></div>
                <v-btn
                  :color="processo.display ? 'primary' : 'info'"
                  large
                  class="mt-2 card-bottom-btn"
                  @click="selecionarUmProcesso(processo)"
                >
                  <v-icon left>{{ processo.icon_btn }}</v-icon>
                  {{ processo.label_btn }}
                </v-btn>
              </div>
            </v-card>
          </v-col>
        </template>
        <template v-else>
          <v-col cols="12" md="8" lg="6" class="d-flex justify-center" v-if="vazio">
            <v-card elevation="8" class="pa-6 text-center card-ajuste card-flex">
              <div class="card-content-flex">
                <v-icon color="grey" size="56">mdi-information-outline</v-icon>
                <h2 class="mt-2 mb-2 font-weight-bold">Nenhuma atividade disponível</h2>
                <p class="mb-4">
                  No momento não há processos ou atividades institucionais ativos para sua participação.<br />Por favor,
                  aguarde novas oportunidades ou entre em contato com a administração para mais informações.
                </p>
                <div class="card-spacer"></div>
              </div>
            </v-card>
          </v-col>
        </template>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "initPage",
  data: () => ({
    processos: [],
    loading: false,
    vazio: false,
  }),
  components: {},
  filters: {},
  computed: {},
  methods: {
    ...mapActions({ requestProcessos: "avaliacao/requestProcessos" }),
    selecionarUmProcesso(processo) {
      this.$store.commit("remocao/setProcessoSelecionado", processo);
      this.$router.push(processo.route);
    },
    async carregarProcessos() {
      this.loading = true;
      try {
        let param = {};
        // param = { display: -1 };
        const resp = await this.requestProcessos(param);

        this.processos = resp.data || [];

        if (this.processos.length === 0) {
          this.vazio = true;
        } else {
          this.vazio = false;
        }
      } catch (e) {
        this.processos = [];
      } finally {
        this.loading = false;
      }
    },
    ajustarAlturaCards() {
      this.$nextTick(() => {
        const cards = Array.from(document.querySelectorAll(".card-ajuste"));
        if (!cards.length) return;
        // Reset height before measuring
        cards.forEach((card) => (card.style.height = "auto"));
        // Calcular a maior altura
        const maxHeight = Math.max(...cards.map((card) => card.offsetHeight));
        // Aplicar a maior altura em todos
        cards.forEach((card) => (card.style.height = maxHeight + "px"));
      });
    },
  },
  mounted: function () {
    this.carregarProcessos();
    window.addEventListener("resize", this.ajustarAlturaCards);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.ajustarAlturaCards);
  },
  watch: {
    processos() {
      this.$nextTick(this.ajustarAlturaCards);
    },
  },
};
</script>

<style scoped>
.v-card.card-flex {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  height: 100%;
}
.card-content-flex {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.card-spacer {
  flex: 1 1 auto;
}
.card-bottom-btn {
  align-self: flex-center;
  margin-top: auto;
}
.v-card {
  border-radius: 18px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  transition: height 0.2s;
}
</style>
